<template>
  <el-form-item>
    <el-input-number
      v-bind="$attrs"
      v-model="startValue_"
      @input="updateValue"
      :min="min"
      :max="typeof endValue_ === 'number' ? endValue_ : max"
      size="mini"
      controls-position="right"
      :placeholder="minPlaceholder"
    />
    {{ connector }}
    <el-input-number
      v-bind="$attrs"
      v-model="endValue_"
      @input="updateValue"
      :min="typeof startValue_ === 'number' ? startValue_ : min"
      :max="max"
      size="mini"
      controls-position="right"
      :placeholder="maxPlaceholder"
    />
  </el-form-item>
</template>

<script>
export default {
  name:'DtNumberRange',
  props: {
    // 数组数值绑定(v-model)
    value: {
      type: Array,
      default: () => [],
    },
    // 起始值绑定(sync)
    startValue: { default: null },
    // 结束值绑定(sync)
    endValue: { default: null },
    // 范围最小值
    min: { default: -Infinity },
    // 范围最大值
    max: { default: Infinity },
    // 未填起始值的替代值
    startDefault: { default: undefined },
    // 未填结束值的替代值
    endDefault: { default: undefined },
    // 最小值文案
    minPlaceholder: {
      type: String,
      default: "最小值",
    },
    // 连接符文案
    connector: {
      type: String,
      default: "-",
    },
    // 最大值文案
    maxPlaceholder: {
      type: String,
      default: "最大值",
    },
  },
  watch: {
    value(val) {
      this.syncValue(val);
    },
    startValue(val) {
      this.syncValue([val, this.endValue_]);
    },
    endValue(val) {
      this.syncValue([this.startValue_, val]);
    },
  },
  data() {
    return {
      startValue_: undefined,
      endValue_: undefined,
    };
  },
  methods: {
    syncValue(valueArr) {
      this.startValue_ = typeof valueArr[0] === "number" ? Math.max(valueArr[0], this.min) : undefined;
      this.endValue_ = typeof valueArr[1] === "number" ? Math.min(valueArr[1], this.max) : undefined;
    },
    updateValue() {
      const start = typeof this.startValue_ === "number" ? this.startValue_ : this.startDefault,
        end = typeof this.endValue_ === "number" ? this.endValue_ : this.endDefault;
      this.$emit("input", [start, end]);
      this.$emit("change", [start, end]);
      this.$emit("update:startValue", start);
      this.$emit("update:endValue", end);
    },
  },
};
</script>
